import Image from 'app/Components/Shared/Image/image';
import React from "react";

const ProgressBarWithIcon=({icon,bgcolor,percentageCompleted})=>{

    const progress = checkProgress(percentageCompleted); 
    const isCompleted = percentageCompleted == 100;

    function checkProgress(percentageCompleted){
        if(!percentageCompleted || percentageCompleted < 0){
            return 0;
        }
        if(percentageCompleted > 100){
            return 100;
        }
        return percentageCompleted;
    }

    return (
        <div className="progress-bar-with-icon-container">
            <div style={{ backgroundColor: bgcolor, width: `${progress}%` }} className="progress-bar" />
            <div className={isCompleted ? "progress-bar-completed" : "icon-and-percentage"} style={{ right: `${progress}%` }}>
                {!isCompleted && <Image className="icon" src={icon} alt="icon" />}
                <div className="percentage">{progress}%</div>
            </div>
        </div>
    );

}
export default ProgressBarWithIcon;